// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QqXJBJVXdp4zYSOAttJp {
  width: 100%;
  background: var(--white);
  z-index: 2
}

.QqXJBJVXdp4zYSOAttJp.FkokOkdxlEINzJschp8o {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 7.5rem;
  }

.JQKUSkXztDpN3uoCUl4u {
  padding: 4rem;
  max-width: 90rem;
  margin: 0 auto;
}

.QyXbpY56YGk9E1MDGLfv {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 3.5fr;
  grid-column-gap: 2rem;
  column-gap: 2rem;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .JQKUSkXztDpN3uoCUl4u {
    padding: 4rem 3.125rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .JQKUSkXztDpN3uoCUl4u {
    padding: 4rem 2.1875rem;
  }

  .QyXbpY56YGk9E1MDGLfv {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .JQKUSkXztDpN3uoCUl4u {
    padding: 1.25rem;
  }

  .QyXbpY56YGk9E1MDGLfv {
    display: flex;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/Search.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB;AASF;;AAPE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,gBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,qBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;;;EACE;IACE,sBAAkB;EACpB;AACF;;AAEA;;;EACE;IACE,uBAAkB;EACpB;;EAEA;IACE,wBAAgB;IAAhB,mBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,gBAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  background: var(--white);\n  z-index: 2;\n\n  &.loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    min-height: 120px;\n  }\n}\n\n.searchContainer {\n  padding: 64px;\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n.search {\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-template-columns: 1fr 3.5fr;\n  column-gap: 32px;\n}\n\n@media (--desktop-small) {\n  .searchContainer {\n    padding: 64px 50px;\n  }\n}\n\n@media (--tablet) {\n  .searchContainer {\n    padding: 64px 35px;\n  }\n\n  .search {\n    column-gap: 20px;\n  }\n}\n\n@media (--mobile) {\n  .searchContainer {\n    padding: 20px;\n  }\n\n  .search {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `QqXJBJVXdp4zYSOAttJp`,
	"loading": `FkokOkdxlEINzJschp8o`,
	"searchContainer": `JQKUSkXztDpN3uoCUl4u`,
	"search": `QyXbpY56YGk9E1MDGLfv`
};
export default ___CSS_LOADER_EXPORT___;
